import { Action } from "../action.type";
import { phoneFormActions } from "./phone-form.actions";
import { PhoneFormState } from "./phone-form.state";
import { PhoneFormActionType as AT } from "./phone-form.action-type.enum";

export const phoneFormReducer = (state = new PhoneFormState(), action: Action<typeof phoneFormActions>): PhoneFormState & Record<string, any> => {
  switch (action.type) {
    case AT.UPDATE_FORM: return { ...state, ...action.payload.fields };
    default: return state;
  }
}